export default __webpack_public_path__ + "static/media/automotive.1c8d4c51.png";